import React, { useState, useEffect } from "react";
import clsx from "clsx";
import { useFormChangeHandler } from "hooks/useFormChangeHandler";
import { useSubmitHandler } from "hooks/useSubmitHandler";
import { useCreateData, useUpdateData } from "hooks/useApiHooks";

const CreatePage = ({ initialData, onSuccess, onError }) => {
  const API_URL = "/supplier";

  // State untuk menyimpan form data. Jika initialData tersedia, isi form untuk update
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    note: "",
  });

  const isUpdateMode = !!initialData; // Cek apakah ini update mode atau create mode

  // API hook untuk create dan update
  const { createData: createProduct } = useCreateData(
    API_URL,
    "suppliers"
  );
  const { updateData: updateProduct } = useUpdateData(
    `${API_URL}/${initialData?.id}`,
    "suppliers"
  );

  // Gunakan hook untuk menangani perubahan form
  const handleChange = useFormChangeHandler(setFormData);

  // Use hook for handling form submission
  const { handleSubmit, isSubmitting, formError } = useSubmitHandler(
    isUpdateMode ? updateProduct : createProduct,
    onSuccess,
    onError
  );

  const handleBeforeSubmit = (e) => {
    e.preventDefault();
    const payload = {
      ...formData,
    };

    handleSubmit(payload, e);
  };

  useEffect(() => {
    // If initialData is provided (for update), fill the form with existing data
    if (initialData) {
      setFormData({
        ...initialData,
        // status: String(initialData.status),
      }); // Adjust based on the structure of initialData
    }
  }, [initialData]);

  return (
    <form
      onSubmit={(e) => handleBeforeSubmit(e)}
      className="d-flex flex-column"
      style={{ height: "100%" }}
    >
      <div className="action-sheet-content flex-grow-1">
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="invoice_number"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Name :
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.name && "is-invalid"
              )}
              id="name"
              placeholder="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
            />
            {formError?.name && (
              <div className="invalid-feedback">{formError.name}</div>
            )}
          </div>
        </div>
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="email"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Email :
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.email && "is-invalid"
              )}
              id="email"
              placeholder="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
            />
            {formError?.email && (
              <div className="invalid-feedback">{formError.email}</div>
            )}
          </div>
        </div>
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="phone"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Phone :
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.phone && "is-invalid"
              )}
              id="phone"
              placeholder="Phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
            />
            {formError?.phone && (
              <div className="invalid-feedback">{formError.phone}</div>
            )}
          </div>
        </div>
        <div className="row mb-3 align-items-center">
          <label
            htmlFor="note"
            className="col-sm-4 col-form-label d-flex justify-content-end"
            style={{ fontSize: "14px" }}
          >
            Note :
          </label>
          <div className="col-sm-8">
            <input
              type="text"
              className={clsx(
                "form-control gotra-form-control rounded-1",
                formError?.note && "is-invalid"
              )}
              id="note"
              placeholder="Note"
              name="note"
              value={formData.note}
              onChange={handleChange}
              disabled={isSubmitting}
              style={{ fontSize: "14px", height: "35px" }}
            />
            {formError?.note && (
              <div className="invalid-feedback">{formError.note}</div>
            )}
          </div>
        </div>
      </div>

      <div className="form-group mt-auto d-grid">
        <button
          type="submit"
          className="btn btn-primary btn-block"
          disabled={isSubmitting}
        >
          {isUpdateMode ? "Update" : "Create"}
        </button>
      </div>
    </form>
  );
};

export default CreatePage;
